import { Navigate, type RouteObject } from "react-router";
import { ADMIN_ROUTES } from "../constants/admin-routes";

export const adminRoutes: RouteObject = {
	children: [
		{
			path: ADMIN_ROUTES.ROOT,
			element: <Navigate to={ADMIN_ROUTES.DASHBOARD} replace />,
		},
		{
			path: ADMIN_ROUTES.DASHBOARD,
			lazy: async () => {
				const { default: AdminDashboardPage } = await import("../pages/admin-dashboard-page");
				return { Component: AdminDashboardPage };
			},
		},
		{
			path: ADMIN_ROUTES.ANALYTICS,
			lazy: async () => {
				const { default: AnalyticsPage } = await import("../pages/analytics-page");
				return { Component: AnalyticsPage };
			},
		},
		{
			path: ADMIN_ROUTES.COMMUNITY,
			lazy: async () => {
				const { default: CommunityPage } = await import("../pages/community-page");
				return { Component: CommunityPage };
			},
		},
		{
			path: ADMIN_ROUTES.MEMBERS,
			lazy: async () => {
				const { default: AdminMembersPage } = await import("../pages/admin-members-page");
				return { Component: AdminMembersPage };
			},
		},
		{
			path: ADMIN_ROUTES.GROUPS,
			lazy: async () => {
				const { default: AdminGroupsPage } = await import("../pages/admin-groups-page");
				return { Component: AdminGroupsPage };
			},
		},
		{
			path: ADMIN_ROUTES.SPONSORSHIP,
			lazy: async () => {
				const { default: SponsorshipPage } = await import("../pages/sponsorship-page");
				return { Component: SponsorshipPage };
			},
		},
		{
			path: ADMIN_ROUTES.API_KEYS,
			lazy: async () => {
				const { default: ApiKeysPage } = await import("../pages/api-keys-page");
				return { Component: ApiKeysPage };
			},
		},
		{
			path: ADMIN_ROUTES.WEBHOOKS,
			lazy: async () => {
				const { default: WebhooksPage } = await import("../pages/webhooks-page");
				return { Component: WebhooksPage };
			},
		},
		{
			path: ADMIN_ROUTES.WEBHOOK_DETAIL,
			lazy: async () => {
				const { default: WebhookDetailPage } = await import("../pages/webhook-detail-page");
				return { Component: WebhookDetailPage };
			},
		},
	],
};
